import 'react-phone-input-2/lib/style.css';
import './PhoneNumberInput.scss';

import { AbsoluteRoutes, allowedCountriesList, getCapitalizeWord, useTranslation } from '../../utils';
import { ErrorMessage, Form, useFormikContext } from 'formik';

import { NavLink } from 'react-router-dom';
import PhoneInput from 'react-phone-input-2';
import type { TPhoneNumberInputProps } from '../../utils/types';
import { useState } from 'react';

const PhoneNumberInput = ({ isOnLine }: TPhoneNumberInputProps) => {
  const { setFieldValue, values, errors, submitCount } = useFormikContext<{ phoneNumber: string }>();
  const [isFocused, setIsFocused] = useState(false);

  const { t } = useTranslation();

  const showError = submitCount > 0 && !!errors.phoneNumber && !values.phoneNumber;
  const showPlaceholder = !isFocused && !values.phoneNumber && !showError;

  return (
    <>
      <h2 className='loginFormHeader'>
        <svg width='20' height='20' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2'>
          <rect x='5' y='2' width='14' height='20' rx='2' />
          <path d='M11 18h2' strokeLinecap='round' strokeLinejoin='round' />
        </svg>
        {getCapitalizeWord(t('Login.Button_login'))}
      </h2>
      <Form className='loginForm'>
        <div className='form-group'>
          <label htmlFor='phoneNumber'>
            <svg width='14' height='14' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2'>
              <path
                d='M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.13.96.36 1.9.68 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.91.32 1.85.55 2.81.68A2 2 0 0 1 22 16.92z'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
            </svg>
            {t('Login.Title_of_the_field_phone')}
          </label>
          <div className='phone-input-wrap'>
            <PhoneInput
              country='us'
              value={values.phoneNumber}
              onlyCountries={allowedCountriesList}
              autoFormat={false}
              onChange={phone => setFieldValue('phoneNumber', phone)}
              inputProps={{
                name: 'phoneNumber',
                required: true,
                onFocus: () => setIsFocused(true),
                onBlur: () => setIsFocused(false),
                onKeyDown: (e: React.KeyboardEvent<HTMLInputElement>) => {
                  if (e.key === 'Enter') {
                    e.preventDefault();
                    const form = e.currentTarget.closest('form');
                    form?.requestSubmit();
                  }
                },
              }}
              containerClass='phone-input'
              inputClass={`form-control${showError ? ' error' : ''}`}
            />
            {showPlaceholder && (
              <span className='phone-input-placeholder'>{t('Web.Placeholder_phone_number')}</span>
            )}
            {showError && !isFocused && (
              <span className='phone-input-placeholder error'>{errors.phoneNumber}</span>
            )}
          </div>
          {!showError && <ErrorMessage name='phoneNumber' component='div' className='error-message' />}
        </div>

        <button type='submit'>{getCapitalizeWord(t('Login.Button_login'))}</button>
      </Form>
      <div className='loginBottomLink'>
        <p>{t('Login.Text_field')}</p>
        <NavLink to={AbsoluteRoutes.signup}>{t('Login.Button_sign_up')}</NavLink>
      </div>
    </>
  );
};

export default PhoneNumberInput;